import * as ActionTypes from 'actions/User';
import * as AuthActionTypes from 'actions/Auth';
import { get } from 'lodash';
import { isUserMatchingId } from 'utils/userIdentity';

const initialState = {
  users: [],
  activeUsers: [],
  inactiveUsers: [],
  activeRentUsers: [],
  inactiveRentUsers: [],
  user: null,
  requestedUserId: null,
  results: null,
  usersPage: 0,
  activeUsersPage: 0,
  inactiveUsersPage: 0,
  activeRentUsersPage: 0,
  inactiveRentUsersPage: 0,
  tableFilter: {},
  tableSorting: {},
  selectedUsers: {},
  achievementsTableFilter: '',
  trainingsTableFilter: '',
  trainingsTableSorting: {},
  isBeautyCareAdmin: true,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case AuthActionTypes.LOGOUT.SUCCESS:
      return { ...initialState };
    case ActionTypes.CLEAR_USER:
      return { ...state, user: null, requestedUserId: null };
    case ActionTypes.SET_USERS_TABLE_FILTER:
      return { ...state, tableFilter: action.payload };
    case ActionTypes.SET_ACHIEVEMENTS_TABLE_FILTER:
      return { ...state, achievementsTableFilter: action.payload };
    case ActionTypes.SET_TRAININGS_TABLE_FILTER:
      return { ...state, trainingsTableFilter: action.payload };
    case ActionTypes.SET_TRAININGS_TABLE_SORTING:
      return { ...state, trainingsTableSorting: action.payload };
    case ActionTypes.SET_USERS_TABLE_SORTING:
      return { ...state, tableSorting: action.payload };
    case ActionTypes.GET_USERS.SUCCESS:
      return {
        ...state,
        users: get(action.payload, 'content'),
        usersPage: get(action, 'payload.currentPage', 0),
        usersPages: get(action, 'payload.totalPages', 0),
      };
    case ActionTypes.GET_ACTIVE_USERS.SUCCESS:
      return {
        ...state,
        activeUsers: get(action.payload, 'content'),
        activeUsersPage: get(action, 'payload.currentPage', 0),
        activeUsersPages: get(action, 'payload.totalPages', 0),
      };
    case ActionTypes.GET_INACTIVE_USERS.SUCCESS:
      return {
        ...state,
        inactiveUsers: get(action.payload, 'content'),
        inactiveUsersPage: get(action, 'payload.currentPage', 0),
        inactiveUsersPages: get(action, 'payload.totalPages', 0),
      };
    case ActionTypes.GET_ACTIVE_RENT_USERS.SUCCESS:
      return {
        ...state,
        activeRentUsers: get(action.payload, 'content'),
        activeRentUsersPage: get(action, 'payload.currentPage', 0),
        activeRentUsersPages: get(action, 'payload.totalPages', 0),
      };
    case ActionTypes.GET_INACTIVE_RENT_USERS.SUCCESS:
      return {
        ...state,
        inactiveRentUsers: get(action.payload, 'content'),
        inactiveRentUsersPage: get(action, 'payload.currentPage', 0),
        inactiveRentUsersPages: get(action, 'payload.totalPages', 0),
      };
    case ActionTypes.SELECT_USERS:
      return {
        ...state,
        selectedUsers: action.payload,
      };
    case ActionTypes.GET_USER.REQUEST:
      return {
        ...state,
        user: null,
        requestedUserId: action.id,
      };
    case ActionTypes.GET_USER.SUCCESS:
      if (!isUserMatchingId(action.payload, state.requestedUserId)) return state;

      return {
        ...state,
        user: action.payload,
      };
    case ActionTypes.GET_USER.FAILURE:
      return {
        ...state,
        user: null,
        requestedUserId: null,
      };
    case ActionTypes.GET_USER_WITH_GROUPS.SUCCESS: {
      const user = get(action, 'payload.user', null);

      return {
        ...state,
        userWithGroups: action.payload,
        user: isUserMatchingId(user, state.requestedUserId) ? user : null,
        userGroups: get(action, 'payload.userGroups', []),
      };
    }
    case ActionTypes.GET_USER_RESULTS.SUCCESS:
      return {
        ...state,
        results: action.payload,
      };
    case ActionTypes.GET_USER_PRODUCTS.SUCCESS:
      return {
        ...state,
        userProducts: action.payload,
      };
    case ActionTypes.IS_BEAUTY_CARE_ADMIN.SUCCESS:
      return {
        ...state,
        isBeautyCareAdmin: action.payload,
      };
    default:
      return state;
  }
}
